import script from "./AddNewVisitModalNew.vue?vue&type=script&setup=true&lang=js"
export * from "./AddNewVisitModalNew.vue?vue&type=script&setup=true&lang=js"

import "./AddNewVisitModalNew.vue?vue&type=style&index=0&id=3ceb598d&lang=scss"
import "./AddNewVisitModalNew.vue?vue&type=style&index=1&id=3ceb598d&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ceb598d"]])

export default __exports__